module.exports = __webpack_public_path__ + "static/img/adventure-1807524.86e01ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adventure-1807524.png
// module id = Z+Ot
// module chunks = 1